import { getDoc, getDocFromServer } from 'firebase/firestore';

/**
 * Single-document read that prefers the server path. Firestore JS 11.x can throw
 * INTERNAL ASSERTION FAILED from getDoc()'s internal snapshot-listener + persistence
 * path; getDocFromServer avoids that route. Falls back to getDoc for offline/cache.
 *
 * @param {import('firebase/firestore').DocumentReference} docRef
 * @returns {Promise<import('firebase/firestore').DocumentSnapshot>}
 */
export async function safeGetDoc(docRef) {
  try {
    return await getDocFromServer(docRef);
  } catch {
    return getDoc(docRef);
  }
}
